export default __webpack_public_path__ + "static/media/kitchen3-afterK-480w.0fe050f6.webp";